<template>
  <Legenda
    titulo="Curva ABC - Faturamento"
    class-content="text-center cursor-help pt-3 mt-n3"
    :top="top"
  >
    <slot>
      <template v-if="texto === 'Z'">A</template>
      <template v-else-if="texto === 'Y'">B</template>
      <template v-else>C</template>
    </slot>

    <template #legenda>
      <p class="ma-0">
        Classificação voltada para o resultado comercial, que visa segmentar de formas distintas a
        importância comercial de um determinado SKU, frente ao faturamento geral.
      </p>

      <ul class="ml-n2 my-1">
        <li>A - Faturamento Elevado</li>
        <li>B - Faturamento Médio</li>
        <li>C - Faturamento Baixo</li>
      </ul>
    </template>
  </Legenda>
</template>

<script>
import Legenda from "../../../produto/detalhes/Legenda.vue";

export default {
  name: "LegendaCurvaAbcFaturamento",
  components: {
    Legenda
  },
  props: {
    texto: String,
    top: Boolean,
    bottom: Boolean,
  }
}
</script>

<style scoped>

</style>
